module.exports = __webpack_public_path__ + "img/dimensions.6f6ddaa9.svg";